// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3140822f","977":"80b46734"}[chunkId] + ".chunk.js";
};